// src/components/products/BackToProductButton.jsx
import React, { useMemo } from "react";
import { Link, useLocation } from "react-router-dom";

/**
 * Returns pathname with the last segment removed (one level up under /products/...).
 * e.g. /products/tracetek/a/b -> /products/tracetek/a
 * Returns null if there is no parent (e.g. /products/brand only).
 */
export const getParentProductPath = (pathname) => {
  if (!pathname || typeof pathname !== "string") return null;
  const normalized = pathname.replace(/\/+$/, "") || "";
  const parts = normalized.split("/").filter(Boolean);
  if (parts.length <= 2) return null;
  parts.pop();
  return `/${parts.join("/")}`;
};

const BackToProductButton = ({ className = "" }) => {
  const { pathname } = useLocation();
  const parentPath = useMemo(() => getParentProductPath(pathname), [pathname]);

  if (!parentPath) return null;

  return (
    <div
      className={`mt-12 md:mt-16 flex justify-center ${className}`.trim()}
    >
      <Link
        to={parentPath}
        className="inline-flex items-center gap-2 px-6 py-3 rounded-full product-btn-primary"
      >
        Back to Product
      </Link>
    </div>
  );
};

export default BackToProductButton;
